import * as React from 'react';

import EnterprisePageHeaderBffProvider from 'bundles/composable-page-header-enterprise/providers/EnterprisePageHeaderBffProvider';

const DefaultEnterprisePageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  return <EnterprisePageHeaderBffProvider>{children}</EnterprisePageHeaderBffProvider>;
};

export default DefaultEnterprisePageHeaderProvider;
